<template>
  <div class="ion-page">
    <template v-if="form">
      <transition-group name="fade">
        <div v-if="showComplete" key="complete">
          <FormComplete :form="form" :result="result" @done="resetForm" />
        </div>
        <div v-else-if="showLanding" key="landing">
          <FormLanding :form="form" @start="startForm" />
        </div>
        <div v-else key="form">
          <Form
            :form="form"
            :state.sync="state"
            @cancel="resetForm"
            @result="onResult"
            @submit="onSubmit"
          />
        </div>
      </transition-group>
    </template>
    <template v-else-if="loading">
      <ion-content class="ion-padding">
        <div class="floating">
          <ion-spinner></ion-spinner>
        </div>
      </ion-content>
    </template>
    <template v-else>
      <ion-content class="ion-padding">
        <div class="floating">
          No form found
        </div>
      </ion-content>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

import {
  restoreFormState,
  saveFormState,
  getDefaultState,
  removeFormState
} from "../utils/formState";
import { getForm } from "../utils/form";

import FormComplete from "../components/Form/FormComplete.vue";
import FormLanding from "../components/Form/FormLanding.vue";
import Form from "../components/Form/Form.vue";

export default {
  name: "FormView",
  components: {
    Form,
    FormLanding,
    FormComplete
  },
  data() {
    return {
      form: undefined,
      loading: false,
      showComplete: false,
      showLanding: true,
      state: getDefaultState(),
      meta: {
        title: document.title
      },
      result: undefined
    };
  },
  created() {
    this.loading = true;
    getForm(this.$route.params.share_code)
      .then(form => {
        this.form = form;
        this.meta = this.getMetaFromForm(form);
        return restoreFormState(form._id);
      })
      .then(({ state, active }) => {
        this.state = state;
        if (active) {
          this.showLanding = false;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  mounted() {
    this.replaceMeta();
  },
  computed: {
    ...mapState(["files"])
  },
  methods: {
    clearState() {
      this.state = getDefaultState();
      setTimeout(() => {
        removeFormState(this.form._id);
      }, 10);
    },
    startForm() {
      this.state = getDefaultState();
      this.showLanding = false;
    },
    resetForm() {
      this.clearState();
      this.showLanding = true;
      this.showComplete = false;
      this.result = undefined;
    },
    onResult(result) {
      this.result = result;
    },
    onSubmit(data) {
      this.showComplete = true;
      this.clearState();
    },
    getMetaFromForm(form) {
      return {
        title: `${form.title} - ${form.subtitle}`
      };
    },
    replaceMeta({ title }) {
      document.title = title;
      const meta = [{ name: "apple-mobile-web-app-title", content: title }];
      meta.forEach(({ name, content }) => {
        const elm = document.querySelector(`meta[name=${name}]`);
        if (elm) {
          elm.setAttribute("content", content);
        }
      });
      this.injectManifest({ title });
    },
    injectManifest({ title }) {
      const manifestElm = document.querySelector("link[rel=manifest]");
      if (manifestElm) {
        const manifestUrl = manifestElm.getAttribute("href");
        fetch(manifestUrl)
          .then(response => response.json())
          .then(manifest => {
            const customManifest = {
              ...manifest,
              name: title,
              short_name: title,
              start_url: window.location.href
            };
            const blob = new Blob([JSON.stringify(customManifest)], {
              type: "application/json"
            });
            manifestElm.setAttribute("href", URL.createObjectURL(blob));
          });
      }
    }
  },
  watch: {
    state: {
      deep: true,
      handler(value) {
        if (this.form && this.form._id) {
          saveFormState(this.form._id, value);
        }
      }
    },
    files: {
      deep: true,
      handler(value) {
        this.state.files = value;
      }
    },
    meta: {
      deep: true,
      handler(value) {
        this.replaceMeta(value);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
